export default "__VITE_ASSET__D244F1kv__"